<template>
  <div class="chair">
    
    <div class="chair-body">
      <div class="front">
        <div class="left-leg"></div>
        <div class="right-leg"></div>
      </div>
      <div class="right">
        <div class="middle"></div>
      </div>
      <div class="left">
        <div class="middle"></div>
      </div>
      <div class="back">
        <div class="left-leg"></div>
        <div class="middle">
          <div class="backrest">
            <div class="top"></div>
            <div class="right"></div>
            <div class="front"></div>
          </div>
          <div class="seat">
            <div class="top"></div>
            <div class="right"></div>
            <div class="front"></div>
          </div>
        </div>
        <div class="right-leg"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Armchair",
}
</script>

<style>
#furniture .chair div {
  box-sizing: content-box;
}
.chair {
  position: absolute;
  left: 680px;
  bottom: -22px;
  display: flex;
  flex-direction: column;
}

.chair .chair-body {
  transform-origin: top right;
  transform: skewX(70deg);
  width: 80px;
  height: 70px;
  display: flex;
}
.chair .chair-body div {
}
.chair .chair-body div .left-leg {
  border-left: 4px ridge var(--light-orange-wood);
  border-radius: 30%/20px;
}
.chair .chair-body div .middle {
  flex: 1 0 auto;
  margin-top: -6px;
  height: 8px;
  width: 95%;
  border-bottom: 4px ridge var(--light-orange-wood);
  border-radius: 50%/6px;
}
.chair .chair-body div .right-leg {
  border-right: 4px ridge var(--light-orange-wood);
  border-radius: 30%/20px;
}
.chair .chair-body .front {
  flex: 1 0 auto;
  display: flex;
  justify-content: space-between;
}
.chair .chair-body .front .left-leg {
}
.chair .chair-body .front .middle {
  background: none;
  border: none;
}
.chair .chair-body .front .right-leg {
  z-index: 1;
}
.chair .chair-body .right {
  position: absolute;
  top: 0;
  right: 0;
  width: 45px;
  transform-origin: top right;
  transform: skewY(-20deg) rotateZ(180deg) rotateX(180deg);
  display: flex;
  justify-content: space-between;
  z-index: 2;
}
.chair .chair-body .right .left-leg {
}
.chair .chair-body .right .middle {
}
.chair .chair-body .right .right-leg {
}
.chair .chair-body .left {
  position: absolute;
  top: 0;
  left: 0;
  width: 45px;
  transform-origin: top left;
  transform: skewY(-20deg) rotateZ(180deg) rotateX(180deg) rotateY(180deg);
  display: flex;
  justify-content: space-between;
  z-index: -1;
}
.chair .chair-body .left .left-leg {
}
.chair .chair-body .left .middle {
}
.chair .chair-body .left .right-leg {
}
.chair .chair-body .back {
  position: absolute;
  top: -30px;
  left: 0;
  height: 110px;
  width: 80px;
  transform: translate(45px, -30px);
  display: flex;
  justify-content: space-between;
}
.chair .chair-body .back .left-leg {
}
.chair .chair-body .back .middle {
}
.chair .chair-body .back .middle .backrest {
  width: 80px;
  height: 50px;
  position: absolute;
  top: 3.5px;
  right: 0px;
  display: flex;
}
.chair .chair-body .back .middle .backrest div {
  background: linear-gradient(to top, var(--fabric), var(--fabric-light));
  border: var(--thin-grey);
  border-radius: 100%/3px;
}
.chair .chair-body .back .middle .backrest .top {
  position: absolute;
  width: 95%;
  right: -2px;
  height: 5px;
  transform-origin: top left;
  transform: skewX(-70deg);
}
.chair .chair-body .back .middle .backrest .right {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 10px;
  transform: skewY(-20deg) translate(0px, 0px);
}
.chair .chair-body .back .middle .backrest .front {
  position: absolute;
  top: 4px;
  left: -10px;
  height: 100%;
  width: 100%;
}
.chair .chair-body .back .middle .seat {
  width: 80px;
  height: 40px;
  position: absolute;
  top: 63px;
  right: 0px;
  display: flex;
}
.chair .chair-body .back .middle .seat div {
  background: linear-gradient(to top, var(--fabric), var(--fabric-light));
  border: var(--thin-grey);
  border-radius: 100%/3px;
}
.chair .chair-body .back .middle .seat .top {
  position: absolute;
  width: 95%;
  height: 20px;
  top: -1px;
  right: -2px;
  transform-origin: top left;
  transform: skewX(-70deg);
}
.chair .chair-body .back .middle .seat .right {
  position: absolute;
  top: -1px;
  right: 0;
  height: 15px;
  width: 52px;
  transform: skewY(-20deg) translate(0px, 0px);
}
.chair .chair-body .back .middle .seat .front {
  position: absolute;
  top: 18px;
  left: -52px;
  height: 15px;
  width: 100%;
}
.chair .chair-body .back .right-leg {
}
</style>


